<template>
    <rkm-modal
        large
        ref="RkmModal"
        :title="titulo"
    >
        <rkm-form ref="Form">
            <rkm-row>
                <rkm-col cols="4">
                    <rkm-form-select
                        label="Mês"
                        :options="mesesDisponiveis"
                        :validations="{ required: true }"
                        :disabled="alterando"
                        show-default-option
                        text-field="descricao"
                        value-field="competencia"
                        v-model="model.competencia"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <label class="mb-2">
                        % Cota APP *
                        <rkm-icon
                            icon="info"
                            color="secondary"
                            class="infor"
                            small
                            v-rkm-popover.hover.top="{ html: true, content: tooltip }"
                        />
                    </label>
                    <rkm-form-input
                        name="percentual"
                        v-model="model.percentual"
                        :validations="{ required: true, min_value: 0, max_value: 100 }"
                        number
                        placeholder="0 a 100"
                    />
                </rkm-col>

                <rkm-col cols="5" class="d-flex align-items-center">
                    <span v-if="resumoLimite" class="text-muted">
                        Disponível ao APP: {{ resumoLimite }}
                    </span>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-button
                        :label="false"
                        color="primary"
                        class="mt-0 float-right"
                        @click.stop="incluir"
                    >
                        {{ alterando ? 'Alterar' : 'Incluir' }}
                    </rkm-button>

                    <rkm-button
                        v-if="alterando"
                        :label="false"
                        color="secondary"
                        class="mt-0 mr-2 float-right"
                        @click.stop="limpar"
                    >
                        Voltar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-table
            :items="mesesParametrizados"
            :fields="fields"
            class="mt-3"
        >
            <template v-slot:head(percentual)>
                % Cota APP
                <rkm-icon
                    icon="info"
                    color="secondary"
                    class="infor"
                    small
                    v-rkm-popover.hover.top="{ html: true, content: tooltip }"
                />
            </template>

            <template v-slot:cell(percentual)="{ item }">
                {{ item.percentual }}%
            </template>

            <template v-slot:cell(cotaQuantidade)="{ item }">
                {{ item.cotaQuantidade !== null ? `${item.cotaQuantidade} exames` : '—' }}
            </template>

            <template v-slot:cell(limiteQuantidade)="{ item }">
                {{ limiteQuantidade(item, item.percentual) }}
            </template>

            <template v-slot:cell(cotaValor)="{ item }">
                {{ item.cotaValor !== null ? `R$ ${formatarValor(item.cotaValor)}` : '—' }}
            </template>

            <template v-slot:cell(limiteValor)="{ item }">
                {{ limiteValor(item, item.percentual) }}
            </template>

            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    color="primary"
                    small
                    title="Editar"
                    @click.stop="alterar(item)"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    color="danger"
                    small
                    title="Excluir"
                    @click.stop="excluir(item)"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <template v-slot:footer="{ cancel }">
            <rkm-button @click="cancel">Fechar</rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
export default {
    computed: {
        meses() {

            return this.item ? this.item.meses || [] : []
        },
        mesesDisponiveis() {

            return this.meses
                .filter(mes => mes.percentual === null || this.competencia(mes) === this.model.competencia)
                .map(mes => ({
                    competencia: this.competencia(mes),
                    descricao: mes.descricao,
                }))
        },
        mesesParametrizados() {

            return this.meses.filter(mes => mes.percentual !== null)
        },
        mesSelecionado() {

            return this.meses.find(mes => this.competencia(mes) === this.model.competencia) || null
        },
        resumoLimite() {

            if (!this.mesSelecionado || !this.percentualInformado(this.model.percentual)) return null

            const limites = []

            if (this.mesSelecionado.cotaQuantidade !== null) {
                limites.push(this.limiteQuantidade(this.mesSelecionado, this.model.percentual))
            }

            if (this.mesSelecionado.cotaValor !== null) {
                limites.push(this.limiteValor(this.mesSelecionado, this.model.percentual))
            }

            return limites.join(' | ')
        },
        fields() {

            const possuiCotaQuantidade = this.meses.some(mes => mes.cotaQuantidade !== null)
            const possuiCotaValor = this.meses.some(mes => mes.cotaValor !== null)

            return [
                { key: 'descricao', label: 'Mês' },
                { key: 'percentual', label: '% Cota APP', class: 'text-center' },
                ...(possuiCotaQuantidade ? [
                    { key: 'cotaQuantidade', label: 'Cota física', class: 'text-center' },
                    { key: 'limiteQuantidade', label: 'Cota física disponível ao APP', class: 'text-center' },
                ] : []),
                ...(possuiCotaValor ? [
                    { key: 'cotaValor', label: 'Cota financeira', class: 'text-center' },
                    { key: 'limiteValor', label: 'Cota financeira disponível ao APP', class: 'text-center' },
                ] : []),
                { key: 'actions', label: 'Ações', class: 'col-min text-center' },
            ]
        },
    },
    data: () => ({
        item: null,
        titulo: '',
        alterando: false,
        model: {
            competencia: null,
            percentual: null,
        },
        tooltip: 'Informe o percentual da cota do mês que poderá ser consumido pelo APP Cidadão. '
            + 'Esse limite controla o canal cidadão e não representa reserva exclusiva do aplicativo.',
    }),
    methods: {
        open(item, titulo) {

            this.item = item
            this.titulo = titulo
            this.limpar()
            this.$refs.RkmModal.show()
        },
        competencia(mes) {

            return `${mes.ano}-${mes.mes}`
        },
        incluir() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid || !this.mesSelecionado) return

                    this.mesSelecionado.percentual = Number(this.model.percentual)
                    this.limpar()
                })
        },
        alterar(mes) {

            this.alterando = true
            this.model.competencia = this.competencia(mes)
            this.model.percentual = mes.percentual
        },
        excluir(mes) {

            if (this.competencia(mes) === this.model.competencia) {
                this.limpar()
            }

            mes.percentual = null
        },
        limpar() {

            this.alterando = false
            this.model.competencia = null
            this.model.percentual = null

            this.$nextTick(() => {
                if (this.$refs.Form) this.$refs.Form.resetValidator()
            })
        },
        percentualInformado(percentual) {

            return percentual !== null && percentual !== undefined && percentual !== ''
        },
        limiteQuantidade(mes, percentual) {

            if (mes.cotaQuantidade === null || !this.percentualInformado(percentual)) return '—'

            return `${Math.floor(mes.cotaQuantidade * Number(percentual) / 100)} exames`
        },
        limiteValor(mes, percentual) {

            if (mes.cotaValor === null || !this.percentualInformado(percentual)) return '—'

            return `R$ ${this.formatarValor(Math.floor(mes.cotaValor * Number(percentual) / 100 * 100) / 100)}`
        },
        formatarValor(valor) {

            return Number(valor).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
    },
}
</script>

<style scoped>
    .infor {
        color: #acacac;
        height: 15px;
        width: 15px !important;
        border-radius: 31px;
        padding: 3px;
        border: 1px solid #c2c2c2;
        vertical-align: middle;
        margin-left: 4px;
    }
</style>
